function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { SVGUniqueID } from "./components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LogoPlate = function LogoPlate(props) {
  return /*#__PURE__*/React.createElement(SVGUniqueID, null, /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "code_ui_icon"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.661 18.247a3.555 3.555 0 0 1-2.53-1.048l-1.32-1.32a2.837 2.837 0 0 1 0-4.007L16 6.683c.36-.36.56-.84.56-1.351a1.914 1.914 0 0 0-3.263-1.352l-2.685 2.684a.833.833 0 0 1-1.179-1.178L12.118 2.8a3.583 3.583 0 0 1 5.06 0 3.583 3.583 0 0 1 0 5.06l-5.189 5.19a1.168 1.168 0 0 0 0 1.65l1.32 1.32c.361.36.841.56 1.352.56a1.9 1.9 0 0 0 1.352-.56 1.9 1.9 0 0 0 .56-1.352 1.9 1.9 0 0 0-.56-1.352l-1.055-1.054a.833.833 0 1 1 1.179-1.179l1.054 1.055a3.555 3.555 0 0 1 1.048 2.53c0 .956-.372 1.854-1.048 2.53a3.555 3.555 0 0 1-2.53 1.048Z",
      fill: "url(#prefix__a)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.677 18.334a2.917 2.917 0 0 1-2.917-2.917V4.584a2.917 2.917 0 0 1 5.834 0v10.833a2.917 2.917 0 0 1-2.917 2.917Z",
      fill: "#7D8EB3"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "prefix__a",
        x1: 14.661,
        y1: 17.481,
        x2: 9.739,
        y2: 12.681,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#4CE5F2"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#48E69B"
        })]
      })
    })]
  })));
};
export default LogoPlate;